import { FormControl } from "@angular/forms";

/**
 * Represents the result of building a form structure.
 * Contains the form controls structure and an error message if present.
 */
export class FormStructureResult {

  /**
   * The structure of the form, mapping control varNames to FormControl instances.
   */
  structure: { [key: string]: FormControl; } = {};

  /**
   * An error message describing any issues encountered while building the form structure, or null if none.
   */
  errorMessage: string | null = null;

}

